import React from 'react';
import SEO from '../components/ui/SEO';
import Button from '../components/ui/Button';
const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfilePage',
  mainEntity: {
    '@type': 'Person',
    name: 'Dr Imtiaz Syed',
    jobTitle: 'Independent Psychiatric Expert Witness',
    url: 'https://medicolegal-psychiatry.co.uk/about',
    image: 'https://cdn.magicpatterns.com/uploads/vPTXagdmQWKZaxnhPCE2i5/linked_in.jpg',
    email: 'enquiries@medicolegal-psychiatry.co.uk',
    description: 'Independent Psychiatric Expert Witness providing medico-legal psychiatric assessments and reports for proceedings in England and Wales.',
    worksFor: {
      '@type': 'Organization',
      name: 'Medicolegal Psychiatry',
      url: 'https://medicolegal-psychiatry.co.uk'
    },
    areaServed: {
      '@type': 'AdministrativeArea',
      name: 'England and Wales'
    },
    knowsAbout: ['Mental capacity assessments', 'PTSD and psychiatric injury', 'Forensic and risk assessment', 'ADHD and autism assessment', 'Clinical negligence psychiatry', 'Expert witness evidence']
  }
};
export default function About() {
  return <main className="min-h-screen bg-white" data-id="element-362" data-mp="23izr6my7o3pl">
      <SEO title="About Dr Imtiaz Syed | Independent Psychiatric Expert Witness" description="Dr Imtiaz Syed, independent psychiatric expert witness. GMC registered, instructed by claimant, defendant and as single joint expert." path="/about" keywords={['Dr Imtiaz Syed', 'independent psychiatric expert witness', 'GMC registered expert witness', 'single joint expert psychiatrist']} imageAlt="Dr Imtiaz Syed, Independent Psychiatric Expert Witness" schema={aboutSchema} data-id="element-363" data-mp="23k1b7gx7g0jg" />
      {/* Hero Section */}
      <section className="bg-primary text-white py-10 pt-24 md:pt-28" data-id="element-364" data-mp="2w7f2aye821vn">
        <div className="container mx-auto px-4" data-id="element-365" data-mp="2r93wqzuymdj8">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4 text-center" data-id="element-366" data-mp="2r67y19bafktq">
            About Dr. Imtiaz Syed – Medico-Legal Psychiatrist & Expert Witness
          </h1>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-12" data-id="element-367" data-mp="1xu9sajuy0ygr">
        <div className="container mx-auto px-4" data-id="element-368" data-mp="1xt85ji4kenj7">
          <div className="flex flex-col lg:flex-row gap-12" data-id="element-369" data-mp="22mb0nuozq51i">
            <div className="lg:w-1/3" data-id="element-370" data-mp="22nvzvxm92c5p">
              <div className="sticky top-24" data-id="element-371" data-mp="27lxikhfrk9gn">
                <img src="https://cdn.magicpatterns.com/uploads/vPTXagdmQWKZaxnhPCE2i5/linked_in.jpg" alt="Dr Imtiaz Syed, Independent Psychiatric Expert Witness, seated in a book-lined study" width="400" height="400" decoding="async" className="w-full rounded-lg shadow-md mb-6 object-cover" data-id="element-372" data-mp="27n8i2526ev1y" />
                <div className="bg-gray-50 rounded-lg p-6 shadow-md" data-id="element-373" data-mp="r6w8r5bn23d9">
                  {/* h2, not h3: this is the first heading after the page H1.
                      Classes unchanged, so rendering is identical. */}
                  <h2 className="text-xl font-serif font-bold text-primary mb-4" data-id="element-374" data-mp="ew4ysp50u63r">
                    Areas of Specialism
                  </h2>
                  <ul className="space-y-2 text-slate" data-id="element-375" data-mp="9xtka13s77f7">
                    <li className="flex items-start" data-id="element-376" data-mp="4z8kg2sfypra">
                      <span className="text-secondary mr-2" data-id="element-377" data-mp="4we34k4q5l23">•</span>
                      <span data-id="element-378" data-mp="12kwe4fxiitz4">
                        Immigration Cases (psychological impact of
                        deportation/removal)
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-379" data-mp="smqg49etu7zj">
                      <span className="text-secondary mr-2" data-id="element-380" data-mp="omg8ytfatbj3">•</span>
                      <span data-id="element-381" data-mp="om6h10ap0uar">Deprivation of Liberty Safeguards (DoLS)</span>
                    </li>
                    <li className="flex items-start" data-id="element-382" data-mp="3dflgxssv4fjq">
                      <span className="text-secondary mr-2" data-id="element-383" data-mp="39cffcygp3cjl">•</span>
                      <span data-id="element-384" data-mp="113z7d7m81yez">Mental Capacity Assessments UK</span>
                    </li>
                    <li className="flex items-start" data-id="element-385" data-mp="1125zjozvh85e">
                      <span className="text-secondary mr-2" data-id="element-386" data-mp="15vqx5fxk0042">•</span>
                      <span data-id="element-387" data-mp="r62vgdlgmzft">PTSD & Complex Trauma Evaluations</span>
                    </li>
                    <li className="flex items-start" data-id="element-388" data-mp="w4mmgsewv1f1">
                      <span className="text-secondary mr-2" data-id="element-389" data-mp="w5fhiw4ic2hc">•</span>
                      <span data-id="element-390" data-mp="1ju76zfqpq6qf">ADHD & Autism in legal contexts</span>
                    </li>
                  </ul>
                  <div className="mt-6" data-id="element-391" data-mp="1osicje9z5v2u">
                    <Button variant="primary" href="/contact" className="w-full" data-id="element-392" data-mp="1or7dfrrh5bi2">
                      Instruct Dr. Syed
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-2/3" data-id="element-393" data-mp="3fyvqhbe7ju3">
              <div className="prose max-w-none" data-id="element-394" data-mp="3h07yp45acde">
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-395" data-mp="3s23mzp53xzwy">
                  Your Trusted Medico-Legal Psychiatry Expert
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-396" data-mp="3n2hchngnyxru">
                  Dr. Imtiaz Syed is a highly experienced and compassionate
                  Psychiatrist, dedicated to providing clear, impartial, and
                  expert medico-legal assessments. With over 20 years of
                  extensive experience in both clinical practice and secure
                  online consultations, Dr. Syed brings a wealth of knowledge
                  and a deep understanding to every case.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-397" data-mp="3j3i7y3yuh30x">
                  A Committed and Reputable Expert Witness
                </h2>
                <p className="text-slate-dark mb-4" data-id="element-398" data-mp="2qk2vjpxaacfd">
                  As a GMC-registered psychiatrist, Dr. Syed specializes in a
                  range of complex medico-legal areas, including:
                </p>
                <ul className="list-disc pl-6 mb-6 text-slate-dark" data-id="element-399" data-mp="3b9nldhxsqriy">
                  <li className="mb-2" data-id="element-400" data-mp="3faz2ez2lu4fj">
                    <strong data-id="element-401" data-mp="3f9xrcull9hxt">Immigration Cases:</strong> Assessing the profound
                    psychological impact of removal or deportation, and
                    evaluating potential risks upon return to an individual's
                    home country.
                  </li>
                  <li className="mb-2" data-id="element-402" data-mp="2scmbbipdy185">
                    <strong data-id="element-403" data-mp="2wcwj90wqn1pn">Deprivation of Liberty Safeguards (DoLS):</strong>{' '}
                    Ensuring individuals' rights are upheld by conducting
                    thorough assessments regarding their capacity to make
                    decisions within the framework of the Mental Capacity Act
                    2005.
                  </li>
                  <li data-id="element-404" data-mp="gkyzfqrz7i5d">
                    <strong data-id="element-405" data-mp="gnuvtao6dyrp">Mental Capacity Assessments:</strong> Meticulously
                    evaluating an individual's ability to understand, retain,
                    use, and weigh information to make specific decisions.
                  </li>
                </ul>
                <p className="text-slate-dark mb-6" data-id="element-406" data-mp="215400npjai6e">
                  Dr. Syed is committed to delivering independent and
                  evidence-based psychiatric evaluations. He provides detailed,
                  objective reports for solicitors, legal teams, and courts,
                  always aiming to clarify complex medical and legal questions
                  with precision and clarity.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-407" data-mp="1ife7k798u8hn">
                  Convenient & Professional Online Consultations
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-408" data-mp="18gf8ngea5r7u">
                  Understanding the importance of accessibility and convenience,
                  Dr. Syed expertly conducts assessments remotely via secure
                  platforms such as Zoom, Skype, and WhatsApp Video Call. This
                  ensures that clients can receive high-standard, professional
                  evaluations from the comfort of their own environment,
                  wherever they are. His evaluations thoughtfully address
                  crucial aspects such as mental health conditions, trauma
                  history, cognitive abilities, and essential risk factors like
                  self-harm or suicidal ideation.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-409" data-mp="1sznqyhfai2gq">
                  Your Assurance of Quality and Integrity
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-410" data-mp="1jxxyd89o8xhd">
                  Dr. Syed takes immense pride in delivering reports that are
                  not only comprehensive and tailored to legal requirements but
                  are also clear, impartial, and robustly objective. He is also
                  experienced in providing expert testimony when required,
                  working closely and effectively with solicitors to ensure all
                  case details are thoroughly understood and presented.
                </p>
                <p className="text-slate-dark mb-6" data-id="element-411" data-mp="12lha93kjc6fk">
                  With a long-standing career built on trust and ethical
                  practice, Dr. Syed ensures the utmost confidentiality,
                  meticulous attention to detail, and strict adherence to the
                  highest ethical and professional standards in all his work. He
                  is a reliable and highly respected choice for medico-legal
                  psychiatric cases.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-412" data-mp="1zbgsxqueglbv">
                  Commitment to Excellence
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-413" data-mp="4yqpahe8bxra">
                  Dr. Syed is dedicated to providing independent, impartial, and
                  evidence-based reports. He is experienced in expert witness
                  testimony in Criminal, Civil, Family, and Immigration courts,
                  ensuring his insights are valuable and accessible in diverse
                  legal contexts.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-414" data-mp="33e48zoifi1am">
                  Accessibility & Professionalism
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-415" data-mp="3v48z83svdijr">
                  Dr. Syed offers a range of consultation options to meet your
                  needs, including remote consultations, in-person clinics,
                  prison visits, and home visits across the UK. This flexibility
                  ensures that high-quality psychiatric assessment is accessible
                  regardless of circumstances or location.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-416" data-mp="ion5gyy79cr0">
                  Ready to Discuss Your Needs?
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-417" data-mp="l7rwsxq5g8nq">
                  Dr. Syed welcomes the opportunity to discuss your specific
                  requirements and how his expertise can assist your case.
                  Please feel free to contact him directly through our contact
                  page.
                </p>
                <div className="mt-8" data-id="element-418" data-mp="z8cgrx7swait">
                  <Button variant="primary" size="lg" href="/contact" data-id="element-419" data-mp="z56qienfr2li">
                    Instruct Dr. Syed
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}